import React from 'react';
import "./MyButtons.css"

const MyButton = ({content, isBlue, onClick}) => {
    return (
        <button onClick={onClick} className={isBlue ? "blue_btn":"btn"}>
            {content}
        </button>
    );
};

export default MyButton;